<script lang="ts" module>
  export type Line = { t: 'head' | 'add' | 'del' | 'ctx'; s: string }
  export type Win = { id: string; d1: string; d2: string; lines?: Line[]; rows?: string[][] }
</script>

<script lang="ts">
  /** KEYS'S WINDOWS (frames 4–6): each change of an NPC's DB opens as a window — D1 the kind of change, D2 the function it touched —
   *  its lines red (before) and green (after); many open at once cascade across the screen. A click brings one to the front. */
  let { wins, onclose, onclear }: { wins: Win[]; onclose: (id: string) => void; onclear: () => void } = $props()
  let order = $state<string[]>([])
  const z = (id: string) => { const i = order.indexOf(id); return i < 0 ? wins.findIndex((w) => w.id === id) : wins.length + i }
  const front = (id: string) => { order = [...order.filter((x) => x !== id), id] }
  // the cascade: a step right and down per window, wrapping so a long history stays on the screen
  const at = (i: number) => `left:${16 + (i % 14) * 34 + Math.floor(i / 14) * 60}px;top:${12 + (i % 14) * 26}px`
</script>

{#if wins.length}
  <div class="layer" aria-label="Open change windows">
    {#each wins as w, i (w.id)}
      <article class="win frame" style={`${at(i)};z-index:${10 + z(w.id)}`} onpointerdown={() => front(w.id)}>
        <header>
          <span class="dtab"><b>D1</b><span class="dot"></span><span class="n">{w.d1}</span></span>
          <span class="dtab two"><b>D2</b><span class="dot"></span><span class="n">{w.d2}</span></span>
          <button class="x" onclick={() => onclose(w.id)} aria-label={`Close ${w.d2}`}>✕</button>
        </header>
        <div class="code mono scroll">
          {#if w.lines}
            {#each w.lines as l}<div class={l.t}>{l.t === 'add' ? '+ ' : l.t === 'del' ? '- ' : l.t === 'head' ? '// ' : '  '}{l.s}</div>{/each}
          {/if}
          {#if w.rows}
            <table><tbody>{#each w.rows as r, ri}<tr class:hi={ri === 0}>{#each r as c}<td>{c}</td>{/each}</tr>{/each}</tbody></table>
          {/if}
        </div>
      </article>
    {/each}
    <button class="btn clear" onclick={onclear}>Close all ({wins.length})</button>
  </div>
{/if}

<style>
  .layer { position: absolute; inset: 0; pointer-events: none; overflow: hidden; }
  .win { position: absolute; width: min(520px, calc(100% - 32px)); background: rgba(10, 14, 19, .97); pointer-events: auto; display: flex; flex-direction: column; max-height: 300px; }
  header { display: flex; align-items: center; gap: 18px; padding: 4px 10px; border-bottom: 1px solid var(--line-dim); background: #0d1218; }
  .dtab b { font-size: 18px; }
  .two { opacity: .65; overflow: hidden; text-overflow: ellipsis; }
  .x { margin-left: auto; color: var(--muted); }
  .code { padding: 8px 12px 10px; overflow: auto; font-size: 12px; line-height: 1.55; white-space: pre-wrap; word-break: break-word; }
  .head { color: var(--muted); }
  .ctx { color: #9fb0bb; }
  .del { color: #ffd5d7; background: var(--red-bg); border-left: 3px solid var(--red); padding-left: 6px; }
  .add { color: #d2ffe9; background: var(--green-bg); border-left: 3px solid var(--green); padding-left: 6px; }
  table { border-collapse: collapse; width: 100%; }
  td { padding: 2px 8px 2px 0; border-bottom: 1px solid #1b242d; color: #b9c7d0; vertical-align: top; }
  tr.hi td { color: var(--cyan); }
  tr:nth-child(4n+2) td { background: rgba(25, 195, 125, .08); }
  .clear { position: absolute; right: 14px; bottom: 12px; pointer-events: auto; z-index: 999; }
</style>
